import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0c9bf374"
var script = {}
import style1 from "./App.vue?vue&type=style&index=1&id=0c9bf374&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports